import React from 'react';

// Catches render-time errors in any routed page (e.g. a malformed cached
// payload from the backend) so a single bad component crashes just that
// page instead of white-screening the entire app.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <h1 className="text-xl font-heading font-bold mb-2">Something went wrong</h1>
            <p className="text-muted-foreground mb-6">
              This page hit an unexpected error. Your data is safe — try reloading, or head back to your dashboard.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-full bg-primary text-primary-foreground font-semibold text-sm"
              >
                Reload
              </button>
              <button
                onClick={() => { window.location.href = '/dashboard'; }}
                className="px-4 py-2 rounded-full border border-input font-semibold text-sm"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
